export default "__VITE_ASSET__BJJ7sYq4__"